<template>
    <vue-final-modal
        v-slot="{ close, params }"
        classes="modal-container"
        content-class="modal-content">
        <div class="vue-dialog-content">
            <div class="vue-dialog-content-title" v-html="params.title || ''" />
            <div v-html="params.message || ''" />
        </div>
        <div class="vue-dialog-buttons" v-if="params.buttons">
            <button
                v-for="(button, index) in params.buttons"
                :class="button.class || 'vue-dialog-button'"
                type="button"
                tabindex="0"
                :style="buttonStyle ? buttonStyle : ''"
                :key="index"
                @click.stop="close"
            >{{ button.title }}</button>
        </div>
        <div v-else class="vue-dialog-buttons-none" />
    </vue-final-modal>
</template>


<script>
export default {
    name: 'VueJsDialog',
    props: {
        buttonStyle: {
            type: String,
            default: ''
        }
    }
}
</script>


<style scoped>

::v-deep(.modal-container) {
    display: flex;
    justify-content: center;
    align-items: center;
}
::v-deep(.modal-content) {
    width: 600px;
    position: relative;
    display: flex;
    flex-direction: column;
    max-height: 90%;
    margin: 0 1rem;
    border: 1px solid #e2e8f0;
    border-radius: 0.25rem;
    background: #fff;
}
.modal__title {
    margin: 0 2rem 0 0;
    font-size: 1.5rem;
    font-weight: 700;
}
.modal__content {
    flex-grow: 1;
    overflow-y: auto;
}
.modal__action {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    padding: 1rem 0 0;
}
.modal__close {
    position: absolute;
    top: 0.5rem;
    right: 0.5rem;
}


.vue-dialog {
    font-size: 14px;
}

.vue-dialog div {
    box-sizing: border-box;
}

.vue-dialog-content {
    flex: 1 0 auto;
    width: 100%;
    padding: 14px;
}

.vue-dialog-content-title {
    font-weight: 600;
    padding-bottom: 14px;
}

.vue-dialog-buttons {
    display: flex;
    flex: 0 1 auto;
    width: 100%;
    border-top: 1px solid #eee;
}

.vue-dialog-buttons-none {
    width: 100%;
    padding-bottom: 14px;
}

.vue-dialog-button {
    font-size: inherit;
    background: transparent;
    padding: 0;
    margin: 0;
    border: 0;
    cursor: pointer;
    box-sizing: border-box;
    line-height: 40px;
    height: 40px;
    color: inherit;
    font: inherit;
    outline: none;
    width: 100%;
}

.vue-dialog-button:hover {
    background: #f9f9f9;
}

.vue-dialog-button:active {
    background: #f3f3f3;
}

.vue-dialog-button:not(:first-of-type) {
    border-left: 1px solid #eee;
}
</style>
